window.addEventListener('load', function(){
  
  // ハンバーガーメニュー左から
  let menu = document.getElementById("NavDrawer");
  if (menu) {
    menu.classList.remove('drawer--right');
    menu.classList.add('drawer--left');
  };
  
  // ヘッダー表示
  let header = document.querySelectorAll('.header-layout');
  header[0].style.opacity = 1;
  
  // 画面に固定で出すバナーを閉じる
  let banner = document.getElementById("linebanner");
  let bannerclose = document.getElementById("linebannerclose");
  if (banner) {
    bannerclose.addEventListener('click', function() {
      banner.style.display ="none";
    });
  };

  //  カテゴリー SPで2列
  const cate = document.querySelectorAll('[id*="featured-collections"]');
  if (cate[0]) {
    const cateitem = cate[0].querySelectorAll('.medium-up--one-half');
  
    if (cateitem[0]) {
      cateitem[0].classList.add('small--one-half');
    };
      if (cateitem[1]) {
        cateitem[1].classList.add('small--one-half');
      };
      if (cateitem[2]) {
          cateitem[2].classList.add('small--one-half');
        };
      if (cateitem[3]) {
        cateitem[3].classList.add('small--one-half');
      };
      if (cateitem[4]) {
        cateitem[4].classList.add('small--one-half');
      };
      if (cateitem[5]) {
        cateitem[5].classList.add('small--one-half');
      };
  };

  // ブログセクション
  document.querySelectorAll('[id*="blog-posts"]').forEach(function(element) {
    element.classList.add('custom-blog-sec');
  });

  // ランキング タブ表示
  const tabranking = document.querySelectorAll('.rank-tab-menu');
  const tabcontent = document.querySelectorAll('.rank-tab-content');
  if (tabranking[0]) {
    tabranking[0].classList.add('click');
    tabcontent[0].classList.add('open');

    for (let i = 0; i < tabranking.length; i++) {
      tabranking[i].addEventListener('click', CommentTabToggle);
    };

    function CommentTabToggle() {
    for (let i = 0; i < tabranking.length; i++) {
        tabranking[i].classList.remove('click');
    };
    for (let i = 0; i < tabcontent.length; i++) {
        tabcontent[i].classList.remove('open');
    };

    this.classList.add('click');
    const Tabs = Array.prototype.slice.call(tabranking);
    const tabIndex = Tabs.indexOf(this);
    tabcontent[tabIndex].classList.add('open');
  };
    
  
  // ランキング タブ ラベル
  if (tabcontent[0]) {
    let tabrankingitem = tabcontent[0].querySelectorAll('.grid-product__image-mask');
    tabrankingitem[0].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.1_0414.png?v=1744611675" class="rank-number rank">');
    tabrankingitem[0].classList.add("rank");
    if (tabrankingitem[1]) {
        tabrankingitem[1].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.2_0414.png?v=1744611687" class="rank-number rank">');
        tabrankingitem[1].classList.add("rank");
        if (tabrankingitem[2]) {
          tabrankingitem[2].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.3_0414.png?v=1744611698" class="rank-number rank">');
          tabrankingitem[2].classList.add("rank");
        };
      };
    if (tabranking[1]) {
      let tabrankingitem1 = tabcontent[1].querySelectorAll('.grid-product__image-mask');
      tabrankingitem1[0].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.1_0414.png?v=1744611675" class="rank-number rank">');
      tabrankingitem1[0].classList.add("rank");
      if (tabrankingitem1[1]) {
        tabrankingitem1[1].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.2_0414.png?v=1744611687" class="rank-number rank">');
        tabrankingitem1[1].classList.add("rank");
        if (tabrankingitem1[2]) {
          tabrankingitem1[2].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.3_0414.png?v=1744611698" class="rank-number rank">');
          tabrankingitem1[2].classList.add("rank");
        };
      };
    };
    if (tabranking[2]) {
      let tabrankingitem2 = tabcontent[2].querySelectorAll('.grid-product__image-mask');
      tabrankingitem2[0].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.1_0414.png?v=1744611675" class="rank-number rank">');
      tabrankingitem2[0].classList.add("rank");
      if (tabrankingitem2[1]) {
        tabrankingitem2[1].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.2_0414.png?v=1744611687" class="rank-number rank">');
        tabrankingitem2[1].classList.add("rank");
        if (tabrankingitem2[2]) {
          tabrankingitem2[2].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.3_0414.png?v=1744611698" class="rank-number rank">');
          tabrankingitem2[2].classList.add("rank");
        };
      };
    };
    if (tabranking[3]) {
      let tabrankingitem3 = tabcontent[3].querySelectorAll('.grid-product__image-mask');
      tabrankingitem3[0].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.1_0414.png?v=1744611675" class="rank-number rank">');
      tabrankingitem3[0].classList.add("rank");
      if (tabrankingitem3[1]) {
        tabrankingitem3[1].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.2_0414.png?v=1744611687" class="rank-number rank">');
        tabrankingitem3[1].classList.add("rank");
        if (tabrankingitem3[2]) {
          tabrankingitem3[2].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.3_0414.png?v=1744611698" class="rank-number rank">');
          tabrankingitem3[2].classList.add("rank");
        };
      };
    };
    if (tabranking[4]) {
      let tabrankingitem4 = tabcontent[4].querySelectorAll('.grid-product__image-mask');
      tabrankingitem4[0].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.1_0414.png?v=1744611675" class="rank-number rank">');
      tabrankingitem4[0].classList.add("rank");
      if (tabrankingitem4[1]) {
        tabrankingitem4[1].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.2_0414.png?v=1744611687" class="rank-number rank">');
        tabrankingitem4[1].classList.add("rank");
        if (tabrankingitem4[2]) {
          tabrankingitem4[2].insertAdjacentHTML('afterbegin', '<img src="https://cdn.shopify.com/s/files/1/0682/1265/4266/files/NO.3_0414.png?v=1744611698" class="rank-number rank">');
          tabrankingitem4[3].classList.add("rank");
        };
      };
    };
  };
  };
    });

document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelectorAll('.details');

  details.forEach(element => {
    const summary = element.querySelector('.details__summary');
    const content = element.querySelector('.details__content');

    summary.addEventListener('click', e => {
      e.preventDefault();
      if (element.open) {
        const openDetails = content.animate(
          {
            opacity: [1, 0],
            height: [content.offsetHeight + 'px', 0],
          },
          {
            duration: 400,
            easing: 'ease-in-out',
          }
        );
        openDetails.onfinish = () => {
          element.removeAttribute('open');
        }
      } else {
        element.setAttribute('open', 'true');
        const openDetails = content.animate(
          {
            opacity: [0, 1],
            height: [0, content.offsetHeight + 'px'],
          },
          {
            duration: 400,
            easing: 'ease-in-out',
          }
        );
      }
    });
  });
});
/* --- カートの赤丸自動切り替え処理 --- */
(function() {
  function updateCartDot() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartLinks = document.querySelectorAll('a[href*="/cart"]');
        cartLinks.forEach(function(link) {
          var badge = link.querySelector('.custom-cart-badge');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'custom-cart-badge';
              link.appendChild(badge);
            }
          } else {
            if (badge) {
              badge.remove();
            }
          }
        });
      })
      .catch(function(e) { console.error(e); });
  }

  // ページ読み込み時・カート更新時に実行
  document.addEventListener('DOMContentLoaded', updateCartDot);
  document.addEventListener('cart:updated', updateCartDot);
  document.addEventListener('page:loaded', updateCartDot);
  window.addEventListener('pageshow', updateCartDot);
})();

// ========================================
// 買い物を続ける：元いたコレクションの位置へ戻る
// ========================================

// コレクションページで商品をクリックした時に
// 「コレクションURL」と「スクロール位置」を記憶
document.addEventListener('click', function (e) {
  const productLink = e.target.closest('a[href*="/products/"]');

  if (
    productLink &&
    window.location.pathname.indexOf('/collections/') === 0
  ) {
    sessionStorage.setItem('kalaeCollectionUrl', window.location.href);
    sessionStorage.setItem('kalaeCollectionScroll', window.scrollY);
  }
});

// カートの「お買い物を続ける」から呼び出す
window.kalaeContinueShopping = function () {
  const collectionUrl = sessionStorage.getItem('kalaeCollectionUrl');

  if (collectionUrl) {
    sessionStorage.setItem('kalaeRestoreCollectionScroll', 'true');
    window.location.href = collectionUrl;
  } else {
    window.location.href = '/collections/新all';
  }

  return false;
};

// 元のコレクションに戻った時、見ていた位置まで戻す
window.addEventListener('load', function () {
  const shouldRestore = sessionStorage.getItem('kalaeRestoreCollectionScroll');
  const savedScroll = sessionStorage.getItem('kalaeCollectionScroll');

  if (
    shouldRestore === 'true' &&
    window.location.pathname.indexOf('/collections/') === 0
  ) {
    sessionStorage.removeItem('kalaeRestoreCollectionScroll');

    setTimeout(function () {
      window.scrollTo(0, Number(savedScroll) || 0);
    }, 300);
  }
});